export default "__VITE_ASSET__DTvJa5Xb__"